import {
  B_17,
  BANNER_DEFAULTS,
  hideB17Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const B17_PLASMIC_PROPS = {
  b17Heading: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_17].heading,
    description: "Main heading (B17 only)",
    hidden: hideB17Props,
  },
  b17Description: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_17].description,
    description: "Description text (B17 only)",
    hidden: hideB17Props,
  },
  b17PrimaryButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_17].primaryButtonText,
    description: "Primary CTA button text (B17 only)",
    hidden: hideB17Props,
  },
  b17PrimaryButtonUrl: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_17].primaryButtonUrl,
    description: "Primary CTA button URL (B17 only)",
    hidden: hideB17Props,
  },
  b17Image: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_17].image,
    description: "Main image (B17 only)",
    hidden: hideB17Props,
  },
  b17ImageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_17].imageAlt,
    description: "Image alt text (B17 only)",
    hidden: hideB17Props,
  },
};
